import { RouteComponentProps } from "../../../../models/RouteComponent";
import { CardActions, CardOverflow, Typography } from "@mui/joy";
import { Button } from "primereact/button";
import React, { useEffect } from "react";
import { IncidentRecord } from "../../../../models/DSF/Incidents";
import useApiService from "../../../../hooks/useApiService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

function IncidentTypes(props: RouteComponentProps) {
  const { session } = props;
  const { data, loading, error } = useApiService<IncidentRecord[]>({
    method: "GET",
    url: "incidents-type",
    apiName: "open",
    params: {
      clientId: session.client_id,
      siteId: session.site_id,
    },
  });

  useEffect(() => {
    props.setGlobalLoader(loading);
  }, [loading]);

  return (
    <>
      <Typography level="h2" component="h1">
        Incident types
      </Typography>
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15, marginBottom: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          <Button
            name="button"
            icon="pi pi-save"
            label="Download PDF"
            className="p-button-outlined"
            size="small"
            disabled={true}
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => {}}
          />
        </CardActions>
      </CardOverflow>
      {error && (
        <div className={"error-wrapper"}>
          <h2>Error fetching the incident types</h2>
        </div>
      )}
      {data && (
        <DataTable value={data}>
          <Column field={"name"} header={"Name"} />
          <Column field={"description"} header={"Description"} />
        </DataTable>
      )}
    </>
  );
}

export default IncidentTypes;
